// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1w0CL","description":"PatientConsentPreview_description__Gu1Db"};